/**
 * Mixin: Search filter {gallery || profile} base sidebar UI logic
 */

import collapseDirective from 'Site/directive/collapse';
import html5Location from 'Site/js/util/location';
import Location from 'Location/component/Location.vue';
import GeocompleteSearch from 'Location/component/GeocompleteSearch.vue';
import Slider from 'Site/component/Slider.vue';
import { mapActions, mapState } from 'vuex';
import { getCookie, setCookie } from '../util/cookie';

/**
 * @mixin
 */
export default {
    components: {
        Location,
        GeocompleteSearch,
        Slider
    },
    data() {
        return {
            preset: '',
            presetSelected: false,
            showperpage: parseInt(getCookie('num-results'), 10) || 25,
            showSearch: false,
            loggedOut: this.$store.state.config.loggedOut || false,
        };
    },
    computed: {
        ...mapState({
            t: state => state.t
        }),
        disableRegionCheck() {
            return this.region.length !== 0 || !!this.loggedOut;
        },
        disableNotice() {
            let message = this.t.label_location;
            if (this.disableRegionCheck && !this.loggedOut) {
                message = this.t.set_region;
            }
            return message;
        },
        showDistanceWrapper() {
            return (this.region.length === 0 && (typeof this.location !== 'undefined' && this.location.length > 0));
        },
        dobSlider() {
            return {
                start: this.dob || [18, 100],
                step: 1,
                connect: true,
                range: {
                    min: 18,
                    max: 100
                }
            };
        },
        distanceSlider() {
            return {
                start: this.distance || 500,
                step: 10,
                connect: 'lower',
                range: {
                    min: 0,
                    max: 500
                }
            };
        },
        // @todo add height to profile search
        heightSlider() {
            return {
                start: this.height || [48, 96],
                step: 1,
                connect: true,
                range: {
                    min: 48,
                    max: 96
                }
            };
        },
        filterText() {
            return this.showSearch ? this.t.show_results : this.t.show_filters;
        }
    },
    directives: {
        collapse: collapseDirective
    },
    methods: {
        ...mapActions(['notify']),
        reset() {
            this.storeReset();
            this.resetOrientation();
            this.preset = '';
        },
        setFilters(filters) {
            this.setStoreFilters(filters);
        },
        unsetFilters(filters) {
            const unsetList = [];
            filters = Array.isArray(filters) ? filters : [filters];
            filters.forEach((filter) => {
                unsetList.push({ key: filter, value: '' });
            });
            this.setFilters(unsetList);
        },
        showSearchToggle() {
            this.showSearch = !this.showSearch;
        },
        getlocation() {
            this.presetSelected = true;
            if (!this.disableRegionCheck) {
                html5Location.retrieve(this.setLocation);
            }
        },
        setLocation(position, locationTxt = this.t.my_location) {
            if (position === 'timeout') {
                this.notify({ type: 'error', msg: this.t.get_location_failed });
                return;
            }
            if (position === 'blocked') {
                this.notify({ type: 'error', msg: this.t.user_blocked_location });
                return;
            }
            html5Location.clearWatch();
            this.setFilters([
                { key: 'latitude', value: position.latitude },
                { key: 'longitude', value: position.longitude },
                { key: 'location', value: locationTxt },
                { key: 'distance', value: this.distance || 500 }
            ]);
        },
        searchregion() {
            this.unsetFilters(['location', 'latitude', 'longitude']);
            if (this.region.length) {
                // Reset distance
                this.setFilters([
                    { key: 'distance', value: 500 }
                ]);
            }
        },
        parseHeight(value) {
            const feet = parseInt(value / 12, 10);
            const inches = value % 12;
            return `${feet}' ${inches}"`;
        },
        updateLocation(result) {
            this.setFilters([
                { key: 'location', value: result.formatted_address },
                { key: 'latitude', value: result.lat },
                { key: 'longitude', value: result.lng },
            ]);
        },
        showJoin() {
            this.$store.dispatch('showJoin');
        },
    },
    updated() {
        if (!this.presetSelected) {
            this.preset = '';
        }
        this.presetSelected = false;
    },
    watch: {
        showperpage(value) {
            setCookie('num-results', value);
        }
    }
};
